import { useCallback, useMemo, useState } from 'react';

import {
  EQnaTab,
  EQuestionSortType,
  EQuestionsSortBy,
  ESortOrder,
  IQnAQuestion,
  IQnASortingRule,
  ITabSorting,
} from '@vimeo/live-core/types/interaction_tools';

export function useQuestionsListSorting(
  listId: EQnaTab,
): [
  IQnASortingRule,
  (tabSorting: ITabSorting) => void,
  (a: IQnAQuestion, b: IQnAQuestion) => number,
] {
  // Sorting state of the tab.
  const [sorting, setSorting] = useState(() => ({
    [EQnaTab.ACTIVE]: {
      type: EQuestionSortType.NEWEST,
      order: ESortOrder.DESCENDING,
      field: EQuestionsSortBy.TIMESTAMP,
    },
    [EQnaTab.APPROVED]: {
      type: EQuestionSortType.NEWEST,
      order: ESortOrder.DESCENDING,
      field: EQuestionsSortBy.TIMESTAMP,
    },
    [EQnaTab.PENDING]: {
      type: EQuestionSortType.NEWEST,
      order: ESortOrder.DESCENDING,
      field: EQuestionsSortBy.TIMESTAMP,
    },
    [EQnaTab.ARCHIVED]: {
      type: EQuestionSortType.NEWEST,
      order: ESortOrder.DESCENDING,
      field: EQuestionsSortBy.ARCHIVED_TIME,
    },
  }));

  const listSorting = useMemo(() => sorting[listId], [sorting, listId]);

  const changeListSorting = useCallback(
    (tabSorting: ITabSorting) => {
      setSorting({ ...sorting, ...tabSorting });
    },
    [sorting],
  );

  const sortingFunction = useCallback(
    (current: IQnAQuestion, next: IQnAQuestion) => {
      const { field, order } = listSorting;

      if (current.hasOwnProperty(field) && next.hasOwnProperty(field)) {
        const compareResult = current[field] - next[field];
        return order === ESortOrder.ASCENDING ? compareResult : -compareResult;
      }

      return 0;
    },
    [listSorting],
  );

  return [listSorting, changeListSorting, sortingFunction];
}
